import packageJson from "../package.json";

function Footer() {
  return (
    <footer
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        backgroundColor: "#f8f9fa",
        color: "#555",
        textAlign: "center",
        borderRadius: "0 10px",
        fontSizeAdjust: "from-font",
        padding: "4px 4px",
        fontSize: "x-small",
        fontFamily: "system-ui, -apple-system, sans-serif",
        zIndex: 1000,
      }}
    >
      <span style={{ fontSize: "x-small" }}>
        🏷️ <strong style={{ fontSize: "x-small" }}>Versión:</strong> {packageJson.version}
      </span>
      <span style={{ fontSize: "x-small" }}> © {new Date().getFullYear()} Uvilor S.A. – Todos los derechos reservados.</span>
    </footer>
  );
}

export default Footer;

